import axios from "axios";

declare const window: any;

export const intro = async () => {
    let dataIntro: any = window.hybrid ? window.intro : await axios.post(
        //"http://localhost:4000/api/client/intro",
        "https://service-cloud-admin-container.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/client/intro",
        { project: window.project_id || "CP50" }
    )

    return dataIntro
}

export const all = async () => {
    let data: any = window.hybrid ? window.client : await axios.post(
        //"http://localhost:4000/api/client",
        "https://service-cloud-admin-container.etm6qeo1eo20q.us-east-1.cs.amazonlightsail.com/api/client",
        { project: window.project_id || "CP50" }
      );

    return data
}